import { render, staticRenderFns } from "./ReleaseNoteForm.vue?vue&type=template&id=00ca9dc9&scoped=true&"
import script from "./ReleaseNoteForm.vue?vue&type=script&lang=js&"
export * from "./ReleaseNoteForm.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNoteForm.vue?vue&type=style&index=0&id=00ca9dc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca9dc9",
  null
  
)

export default component.exports